<template>
<v-dialog v-model='dialog' width='460' :fullscreen='$vuetify.breakpoint.xs' >
  <template v-slot:activator="{ on, attrs }">
    <v-btn small flat
      v-if='appointmentId && relationshipId'
      :loading='request.loading'
      :disabled='disabled'
      v-bind="attrs"
      v-on="on" >{{cta}}
    </v-btn>
  </template>
  <!-- <pre v-text="appointment" class="caption" /> -->
  <v-window v-model="step" vertical touchless >
    <v-window-item >
      <v-card flat >
        <v-card-title class='subtitle-1 overline grey lighten-4 py-1' >
          Please confirm
          <v-spacer/>
          <v-btn @click="dialog=false" icon small ><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text>
          <v-subheader class="overline pa-0" >
            These codes will automatically be added to new appointments
          </v-subheader>
          For <strong>{{clientName}}</strong> with <strong>{{practitionerName}}</strong><br/>
          for new appointments after
          <strong v-if='startDate' v-text='startDate' />
          <template v-if='stopDate' > until <strong v-if='stopDate' v-text='stopDate' /></template>
          <v-divider/>
          <v-subheader class="overline pl-1" >Apply to all new appointments: </v-subheader>
          <v-layout row wrap >
            <v-flex xs6>
              <v-text-field box hide-details readonly
                @click='dateFocus="start"'
                :class="{'blue lighten-4': (dateFocus === 'start')}"
                label='Created after'
                :value='startDate' />
            </v-flex>
            <v-flex xs6>
              <v-text-field box readonly hide-details clearable
                @click='dateFocus="stop"'
                @click:clear='stopDate=null'
                :class="{'blue lighten-4': (dateFocus === 'stop')}"
                placeholder="Until forever"
                label='Until (leave blank for forever)'
                :value='stopDate' />
            </v-flex>
            <v-flex xs12>
              <v-subheader v-if='dateFocus==="start"' class='overline pl-1' >Choose a start date on the calendar</v-subheader>
              <v-subheader v-if='dateFocus==="stop"' class='overline pl-1' >Choose a stop date on the calendar</v-subheader>
              <v-date-picker no-title flat full-width
                v-model='startStopDate'
                :min='calMin'
                :max='calMax'
                @change='dateSelected'
                class='elevation-0' />
            </v-flex>
          </v-layout>
          <v-layout>

          </v-layout>
          <!-- <v-checkbox class='caption' persistent-hint
            v-model='clearExisting'
            label="Clear any existing auto-codes for this client"
            hint="Will remove 'automatically add to new appointments for any auto-codes " /> -->
          <!-- <pre v-text="appointment" /> -->
        </v-card-text>

        <v-divider/>
        <v-card-actions >
          <v-btn flat @click='dialog=false' >Cancel</v-btn>
          <v-spacer />
          <v-btn color='primary' @click='setCodes' :loading='request.loading' >Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-window-item>
    <v-window-item >
      <v-card flat>
        <v-card-title class='subtitle-1 overline' >
          <v-icon small color='success' class='mr-2' >check_circle</v-icon>
          Auto-codes have been added to this client
        </v-card-title>
        <v-divider/>
        <v-card-text v-if='request.result' >
          <div>{{request.result.description}}</div>
          <v-subheader class='overline pl-0' >Codes</v-subheader>
          <div
            class='caption'
            v-text='request.result.codes_formatted' />

        </v-card-text>
        <v-card-actions >
          <v-spacer/>
          <v-btn @click='dialog=false;step=0' flat >Done</v-btn>
        </v-card-actions>
        <v-divider/>
        <v-footer class='caption pl-1'>
          <v-icon small class='mr-1' >info</v-icon>
          You can manage auto-codes for a client from the client detail page on the "codes" tab
        </v-footer>
      </v-card>
    </v-window-item >
  </v-window>
</v-dialog>
</template>
<script>
export default {
  name: 'CloneAppointmentCodes',
  props: {
    appointment: { type: Object, required: true },
    cta: { type: String, default: 'Always use these codes for this client' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      step: 0,
      dialog: false,
      startDate: null,
      stopDate: null,
      dateFocus: 'start',
      clearExisting: false,
      request: {
        resource: 'ag.spaces.relationships',
        method: 'post',
        extra: 'actions/set_treatment_codes'
      }
    }
  },
  computed: {
    requestStatus () {
      return this.request.status
    },
    appointmentId () {
      if (this.appointment) {
        return this.appointment.id
      }
      return null
    },
    relationshipId () {
      return this.getObjectPath(this.appointment, 'computed_relationship_id')
    },
    practitionerName () {
      let fname = this.getObjectPath(this.appointment, 'practitioner.first_name', '')
      let lname = this.getObjectPath(this.appointment, 'practitioner.last_name', '')
      return fname + ' ' + lname
    },
    clientName () {
      let fname = this.getObjectPath(this.appointment, 'client.first_name', '')
      let lname = this.getObjectPath(this.appointment, 'client.last_name', '')
      return fname + ' ' + lname
    },
    startStopDate: {
      get () {
        if (this.dateFocus === 'start') {
          return this.startDate
        }
        if (this.dateFocus === 'stop') {
          return this.stopDate
        }
        return null
      },
      set (val) {
        if (this.dateFocus === 'start') {
          this.startDate = val
        }
        if (this.dateFocus === 'stop') {
          this.stopDate = val
        }
      }
    },
    calMin () {
      if (this.dateFocus === 'stop') {
        return this.startDate
      }
      return null
    },
    calMax () {
      if (this.dateFocus === 'start') {
        return this.stopDate
      }
      return null
    }
  },
  watch: {
    requestStatus () {
      if (this.requestStatus === 200) { this.step = 1 }
    },
    appointmentId: {
      immediate: true,
      handler () {
        this.step = 0
        if (this.appointment && this.appointment.start_time) {
          this.startDate = this.dateformat(this.appointment.start_time, 'YYYY-MM-DD')
        }
      }
    }
  },
  methods: {
    setCodes () {
      this.request.data = {appointment: this.appointmentId}
      if (this.startDate) {
        this.request.data.start_date = this.startDate
      }
      if (this.stopDate) {
        this.request.data.stop_date = this.stopDate
      }
      if (this.clearExisting) {
        this.request.data.terminate_existing_logs = true
      }
      this.request.resourceId = this.relationshipId
      this.$request('save', this.request)
    },
    dateSelected () {
      if (this.dateFocus === 'start') { this.dateFocus = 'stop' }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CloneAppointmentCodes.vue?77ff658f